import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {
    FaqWrapper,
    FaqTitle,
    FaqList,
    StyledAccordion,
    StyledAccordionSummary,
    StyledAccordionDetails,
} from '../../styles/FaqSection.style';

export interface FaqItem {
    question: string;
    answer: string;
}

interface FaqSectionProps {
    title?: string;
    items: FaqItem[];
}

const FaqSection: React.FC<FaqSectionProps> = ({ title = 'Questions fréquentes', items }) => {
    const faqSchema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: items.map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
            },
        })),
    };

    return (
        <FaqWrapper>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
            </Helmet>
            <FaqTitle>{title}</FaqTitle>
            <FaqList>
                {items.map((item, index) => (
                    <StyledAccordion key={index} disableGutters elevation={0}>
                        <StyledAccordionSummary expandIcon={<AddIcon />}>
                            <Typography component="h3" sx={{ fontWeight: 700, textAlign: 'left', color: '#F1F1F9' }}>
                                {item.question}
                            </Typography>
                        </StyledAccordionSummary>
                        <StyledAccordionDetails>
                            <Typography sx={{ textAlign: 'left', color: 'rgba(255, 255, 255, 0.82)' }}>
                                {item.answer}
                            </Typography>
                        </StyledAccordionDetails>
                    </StyledAccordion>
                ))}
            </FaqList>
        </FaqWrapper>
    );
};

export default FaqSection;
